/* ═══════════════════════════════════════════════════════
   Smith's Blades — Customize Modal JS
   
   NATIVE FORM SUBMISSION:
   - Uses Shopify's {% form 'contact' %} with native submission
   - Client-side validation only (no AJAX/fetch)
   - Success detected via URL parameter after redirect
   - Shopify handles CSRF tokens automatically
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ════════════════════════════════════════
     DOM REFS
     ════════════════════════════════════════ */
  var overlay        = null;
  var modal          = null;
  var form           = null;
  var formWrap       = null;
  var isOpen         = false;
  var currentProduct = { title: '', url: '', handle: '' };

  /* ════════════════════════════════════════
     INIT
     ════════════════════════════════════════ */
  function init() {
    overlay  = document.getElementById('customizeOverlay');
    modal    = document.getElementById('customizeModal');
    form     = document.getElementById('customizeForm');
    formWrap = document.getElementById('customizeFormWrap');

    if (!overlay || !modal || !form) {
      console.warn('[SmithsCustomize] Core elements missing');
      return;
    }

    /* Set anti-spam timestamp */
    var tsField = document.getElementById('customizeTimestamp');
    if (tsField) tsField.value = String(Date.now());

    bindTriggers();
    bindClose();
    bindValidation();
    bindCharCounter();
    bindFileUpload();
    bindSubmit();

    /* Check for success redirect on page load */
    checkForSuccess();
  }

  /* ════════════════════════════════════════
     CHECK FOR SUCCESS (URL PARAM)
     ════════════════════════════════════════ */
  function checkForSuccess() {
    var url = window.location.href;
    
    /* Shopify contact form redirects with ?contact[posted]=true or similar */
    if (url.indexOf('contact') !== -1 && 
        (url.indexOf('posted') !== -1 || url.indexOf('success') !== -1)) {
      
      /* Store success flag in sessionStorage so we only show once */
      if (!sessionStorage.getItem('customize_success_shown')) {
        sessionStorage.setItem('customize_success_shown', '1');
        
        /* Open modal and show success */
        setTimeout(function() {
          openModal('', '', '');
          showSuccess();
          
          /* Clean URL without page refresh */
          if (window.history && window.history.replaceState) {
            var cleanUrl = window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
          }
        }, 500);
      }
    }
  }

  /* ════════════════════════════════════════
     OPEN / CLOSE
     ════════════════════════════════════════ */
  function openModal(productTitle, productUrl, productHandle) {
    if (isOpen) return;

    currentProduct = {
      title:  productTitle  || getPageProductTitle(),
      url:    productUrl    || window.location.href,
      handle: productHandle || getPageProductHandle()
    };

    /* Show product name in header */
    var nameEl = document.getElementById('customizeProductName');
    if (nameEl) {
      nameEl.textContent = currentProduct.title
        ? '\u2014 ' + currentProduct.title + ' \u2014'
        : '';
    }

    /* Reset UI */
    resetModalState();

    /* Open */
    overlay.classList.add('is-active');
    isOpen = true;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeydown);

    /* Focus first field */
    setTimeout(function () {
      var first = form && form.querySelector('.customize-input');
      if (first) first.focus();
    }, 320);
  }

  function closeModal() {
    if (!isOpen) return;
    overlay.classList.remove('is-active');
    isOpen = false;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeydown);
    
    /* Clear success flag when closing */
    sessionStorage.removeItem('customize_success_shown');
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function resetModalState() {
    if (formWrap) formWrap.hidden = false;
    
    var successEl = document.getElementById('customizeSuccess');
    if (successEl) successEl.hidden = true;

    hideErrorBanner();
    resetSubmitButton();

    if (form) {
      form.querySelectorAll('.customize-field').forEach(function (f) {
        f.classList.remove('has-error', 'is-valid');
      });
      form.reset();
    }

    var counter = document.getElementById('customizeCharCounter');
    if (counter) {
      counter.textContent = '0 / 2000';
      counter.classList.remove('is-near-limit', 'is-at-limit');
    }

    var preview  = document.getElementById('customizeFilePreview');
    var dropzone = document.getElementById('customizeDropzone');
    if (preview)  preview.hidden = true;
    if (dropzone) dropzone.style.display = '';
    setVal('customizeFileRef', '');

    var tsField = document.getElementById('customizeTimestamp');
    if (tsField) tsField.value = String(Date.now());
  }

  /* ════════════════════════════════════════
     BIND TRIGGERS
     ════════════════════════════════════════ */
  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-customize-trigger]');
      if (trigger) {
        e.preventDefault();
        openModal(
          trigger.dataset.productTitle  || '',
          trigger.dataset.productUrl    || '',
          trigger.dataset.productHandle || ''
        );
        return;
      }

      var spBtn = e.target.closest('.sp-btn--secondary');
      if (spBtn) {
        var href = spBtn.getAttribute('href') || '';
        if (href.indexOf('customize') !== -1) {
          e.preventDefault();
          openModal(
            getPageProductTitle(),
            window.location.href,
            getPageProductHandle()
          );
        }
      }
    });
  }

  function bindClose() {
    var closeBtn     = document.getElementById('customizeClose');
    var successClose = document.getElementById('customizeSuccessClose');

    if (closeBtn)     closeBtn.addEventListener('click', closeModal);
    if (successClose) successClose.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }

  /* ════════════════════════════════════════
     FIELD VALIDATION CONFIG
     ════════════════════════════════════════ */
  var FIELDS = [
    {
      id:       'customizeFullName',
      required: true,
      filter:   function (v) { return v.replace(/[^a-zA-ZÀ-ÿ\s\-\'.]/g, ''); },
      validate: function (v) { return v.trim().length >= 2; },
      message:  'Please enter your name (at least 2 characters)'
    },
    {
      id:       'customizeEmail',
      required: true,
      validate: function (v) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
      },
      message: 'Please enter a valid email address'
    },
    {
      id:       'customizePhone',
      required: false,
      filter:   function (v) { return v.replace(/[^\d+\-() ]/g, ''); },
      validate: function (v) {
        if (!v.trim()) return true;
        var d = v.replace(/\D/g, '');
        return d.length >= 7 && d.length <= 15;
      },
      message: 'Please enter a valid phone number'
    },
    {
      id:       'customizeDetails',
      required: true,
      validate: function (v) { return v.trim().length >= 10; },
      message:  'Please describe your customization (at least 10 characters)'
    }
  ];

  function resolveField(cfg) {
    var input   = document.getElementById(cfg.id);
    var wrapper = input ? input.closest('.customize-field') : null;
    return { input: input, wrapper: wrapper, cfg: cfg };
  }

  function validateOne(f) {
    if (!f.input || !f.wrapper) return true;
    var val = f.input.value;

    if (!f.cfg.required && !val.trim()) {
      f.wrapper.classList.remove('has-error', 'is-valid');
      return true;
    }
    if (f.cfg.required && !val.trim()) {
      markError(f, f.cfg.message);
      return false;
    }
    if (!f.cfg.validate(val)) {
      markError(f, f.cfg.message);
      return false;
    }
    f.wrapper.classList.remove('has-error');
    f.wrapper.classList.add('is-valid');
    return true;
  }

  function markError(f, msg) {
    f.wrapper.classList.add('has-error');
    f.wrapper.classList.remove('is-valid');
    var el = f.wrapper.querySelector('.customize-field-error');
    if (el && msg) el.textContent = msg;
  }

  function bindValidation() {
    FIELDS.forEach(function (cfg) {
      var f = resolveField(cfg);
      if (!f.input) return;

      if (cfg.filter) {
        f.input.addEventListener('input', function () {
          var filtered = cfg.filter(this.value);
          if (filtered !== this.value) this.value = filtered;
        });
      }

      f.input.addEventListener('blur', function () {
        validateOne(resolveField(cfg));
      });

      f.input.addEventListener('input', function () {
        var ff = resolveField(cfg);
        if (ff.wrapper && ff.wrapper.classList.contains('has-error')) {
          validateOne(ff);
        }
      });
    });
  }

  /* ════════════════════════════════════════
     CHARACTER COUNTER
     ════════════════════════════════════════ */
  function bindCharCounter() {
    var textarea = document.getElementById('customizeDetails');
    var counter  = document.getElementById('customizeCharCounter');
    if (!textarea || !counter) return;
    var max = parseInt(textarea.getAttribute('maxlength'), 10) || 2000;

    function update() {
      var len = textarea.value.length;
      counter.textContent = len + ' / ' + max;
      counter.classList.remove('is-near-limit', 'is-at-limit');
      if (len >= max)             counter.classList.add('is-at-limit');
      else if (len >= max * 0.9)  counter.classList.add('is-near-limit');
    }
    textarea.addEventListener('input', update);
    update();
  }

  /* ════════════════════════════════════════
     FILE UPLOAD (PREVIEW ONLY)
     ════════════════════════════════════════ */
  function bindFileUpload() {
    var dropzone  = document.getElementById('customizeDropzone');
    var fileInput = document.getElementById('customizeImageRefFile');
    var preview   = document.getElementById('customizeFilePreview');
    var removeBtn = document.getElementById('customizeFileRemove');
    var hiddenRef = document.getElementById('customizeFileRef');
    var nameEl    = document.getElementById('customizeFileName');
    var sizeEl    = document.getElementById('customizeFileSize');
    var thumbEl   = document.getElementById('customizeFileThumb');

    if (!dropzone || !fileInput) return;

    var MAX     = 5 * 1024 * 1024;
    var ALLOWED = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'];

    fileInput.addEventListener('change', handleFile);

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    });
    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('is-dragover');
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer && e.dataTransfer.files.length) {
        try { fileInput.files = e.dataTransfer.files; } catch (x) {}
        handleFile();
      }
    });

    if (removeBtn) removeBtn.addEventListener('click', clearFile);

    function handleFile() {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;

      if (ALLOWED.indexOf(file.type) === -1) {
        showErrorBanner('Please select a JPG, PNG, GIF, WebP, or PDF file.');
        clearFile();
        return;
      }
      if (file.size > MAX) {
        showErrorBanner('File must be under 5 MB.');
        clearFile();
        return;
      }

      /* Store file info as a note in hidden field */
      if (hiddenRef) hiddenRef.value = 'File attached: ' + file.name + ' (' + fmtBytes(file.size) + ')';
      if (nameEl)    nameEl.textContent = file.name;
      if (sizeEl)    sizeEl.textContent = fmtBytes(file.size);

      if (thumbEl) {
        if (file.type.indexOf('image') === 0) {
          var reader = new FileReader();
          reader.onload = function (ev) {
            thumbEl.innerHTML = '<img src="' + ev.target.result + '" alt="Preview">';
          };
          reader.readAsDataURL(file);
        } else {
          thumbEl.innerHTML = fileSVG();
        }
      }

      if (preview) preview.hidden = false;
      dropzone.style.display = 'none';
      
      /* Append file info to customization details */
      var detailsField = document.getElementById('customizeDetails');
      if (detailsField && detailsField.value.indexOf('Reference file:') === -1) {
        detailsField.value += '\n\n---\nReference file: ' + file.name;
      }
    }

    function clearFile() {
      fileInput.value = '';
      if (hiddenRef) hiddenRef.value = '';
      if (preview)   preview.hidden = true;
      if (thumbEl)   thumbEl.innerHTML = fileSVG();
      dropzone.style.display = '';
      
      /* Remove file reference from details */
      var detailsField = document.getElementById('customizeDetails');
      if (detailsField) {
        detailsField.value = detailsField.value.replace(/\n\n---\nReference file:[^\n]+/, '');
      }
    }

    function fmtBytes(b) {
      if (b < 1024)    return b + ' B';
      if (b < 1048576) return (b / 1024).toFixed(1) + ' KB';
      return (b / 1048576).toFixed(1) + ' MB';
    }

    function fileSVG() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
           + '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>'
           + '<polyline points="13 2 13 9 20 9"/></svg>';
    }
  }

  /* ════════════════════════════════════════
     FORM SUBMIT (CLIENT VALIDATION ONLY)
     ════════════════════════════════════════ */
  function bindSubmit() {
    if (!form) return;

    form.addEventListener('submit', function (e) {
      
      /* Anti-spam: honeypot */
      var hp = document.getElementById('customizeHoneypot');
      if (hp && hp.value.trim() !== '') {
        e.preventDefault();
        return;
      }

      /* Anti-spam: minimum fill time */
      var tsEl    = document.getElementById('customizeTimestamp');
      var elapsed = tsEl ? Date.now() - parseInt(tsEl.value || '0', 10) : 9999;
      if (elapsed < 2500) {
        e.preventDefault();
        return;
      }

      /* Client validation */
      var valid    = true;
      var firstBad = null;

      FIELDS.forEach(function (cfg) {
        var f = resolveField(cfg);
        if (!validateOne(f)) {
          valid = false;
          if (!firstBad) firstBad = f.input;
        }
      });

      if (!valid) {
        e.preventDefault();
        if (firstBad) {
          firstBad.focus();
          firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      /* Inject product info into message body */
      injectProductInfo();

      /* Show loading state */
      setSubmitLoading(true);
      hideErrorBanner();

      /* Let the form submit naturally — Shopify handles everything */
    });
  }

  /* ════════════════════════════════════════
     INJECT PRODUCT INFO INTO BODY
     ════════════════════════════════════════ */
  function injectProductInfo() {
    var detailsField = document.getElementById('customizeDetails');
    if (!detailsField) return;

    var productInfo = '\n\n' +
      '═══════════════════════════════════════\n' +
      'PRODUCT: ' + currentProduct.title + '\n' +
      'URL: ' + currentProduct.url + '\n' +
      '═══════════════════════════════════════';

    /* Only append if not already there */
    if (detailsField.value.indexOf('PRODUCT:') === -1) {
      detailsField.value += productInfo;
    }
  }

  /* ════════════════════════════════════════
     UI HELPERS
     ════════════════════════════════════════ */
  function showSuccess() {
    if (formWrap) formWrap.hidden = true;
    var successEl = document.getElementById('customizeSuccess');
    if (successEl) {
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    if (modal) modal.scrollTop = 0;
  }

  function showErrorBanner(msg) {
    var banner = document.getElementById('customizeErrorBanner');
    var text   = document.getElementById('customizeErrorText');
    if (!banner) return;
    if (text) text.textContent = msg || 'Something went wrong.';
    banner.hidden = false;
    banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideErrorBanner() {
    var banner = document.getElementById('customizeErrorBanner');
    if (banner) banner.hidden = true;
  }

  function setSubmitLoading(on) {
    var btn      = document.getElementById('customizeSubmit');
    var textSpan = btn && btn.querySelector('.customize-submit__text');
    var loadSpan = btn && btn.querySelector('.customize-submit__loading');
    if (!btn) return;
    btn.disabled = on;
    if (textSpan) textSpan.hidden = on;
    if (loadSpan) loadSpan.hidden = !on;
  }

  function resetSubmitButton() {
    var btn      = document.getElementById('customizeSubmit');
    var textSpan = btn && btn.querySelector('.customize-submit__text');
    var loadSpan = btn && btn.querySelector('.customize-submit__loading');
    if (!btn) return;
    btn.disabled = false;
    if (textSpan) textSpan.hidden = false;
    if (loadSpan) loadSpan.hidden = true;
  }

  /* ════════════════════════════════════════
     PAGE PRODUCT DETECTION
     ════════════════════════════════════════ */
  function getPageProductTitle() {
    var h1 = document.querySelector('.sp-info__title');
    if (h1) return h1.textContent.trim();
    var h1any = document.querySelector('h1');
    if (h1any) return h1any.textContent.trim();
    return document.title;
  }

  function getPageProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* ════════════════════════════════════════
     UTILS
     ════════════════════════════════════════ */
  function getVal(id) {
    var el = document.getElementById(id);
    return el ? el.value : '';
  }

  function setVal(id, val) {
    var el = document.getElementById(id);
    if (el) el.value = val;
  }

  /* ════════════════════════════════════════
     PUBLIC API
     ════════════════════════════════════════ */
  window.SmithsCustomize = { open: openModal, close: closeModal };

  /* ════════════════════════════════════════
     BOOT
     ════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();